import registerVolumeErrorForMissingTurboFrame from '../turbo_volume_error'

document.addEventListener('turbo:frame-missing', (event) => {
  if (event.target.id.includes('envkv-emissions')) {
    event.target.remove()
  }
})

registerVolumeErrorForMissingTurboFrame('envkv-emissions')
